import { Box, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const Actions = customStyled(Box)<{}>(({ theme: { space } }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: space[1],
}));

export const Cancel = customStyled(RoundCornerButton)(({ theme: { colors } }) => ({
  color: colors.blue,
}));

export const Continue = customStyled(RoundCornerButton)(() => ({}));

export const CurrencyList = customStyled(Box)<{}>(({ theme: { space } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: space[3],
  marginBottom: space[3],
}));

export const CustomRadio = customStyled('input')(({ theme: { space, colors } }) => ({
  accentColor: colors.blue,
  scale: '1.5',
  marginRight: space[2],
}));

export const CustomLabel = customStyled('label')(({ theme: { space } }) => ({
  display: 'flex',
  gap: space[1],
  alignItems: 'center',
  cursor: 'pointer',
}));

export const StyledLabel = customStyled(Box)<{}>(({ theme: { space } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: space[1],
}));

export const ConversionRate = customStyled(Box)<{}>(({ theme: { colors } }) => ({
  color: colors.GRAY_900,
}));

export const Currency = customStyled(Box)<{ selected: boolean }>(
  ({ theme: { fontWeights, colors }, selected }) => ({
    fontWeight: selected ? fontWeights[6] : fontWeights[3],
    color: selected ? colors.blue : colors.black,
  })
);
